// extracted by mini-css-extract-plugin
export default {"wrapper":"V1-z","play":"W1-z"};